import modal from './modal'

export default modal
